import { useMemo } from "react";
import { fileUrl } from "@/lib/upload";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" }) : "");

export const htmlPlaceholders = (d, { loginPath, ctaPath }) => {
  const o = window.location.origin;
  return {
    CONTEST_NAME: d.name,
    CTA_URL: d.channel === "whatsapp" && d.whatsapp_number ? `https://wa.me/${d.whatsapp_number.replace(/\D/g, "")}?text=${encodeURIComponent("Ciao! Voglio partecipare a " + d.name)}` : `${o}${ctaPath}`,
    LOGIN_URL: `${o}${loginPath}`,
    RULES_URL: `${o}/regolamento/${d.id}`,
    PRIVACY_URL: `${o}/privacy/${d.id}`,
    RECEIPT_URL: `${o}/scontrino/${d.id}`,
    LOGO_URL: fileUrl(d.logo_file_id) || d.logo_url || "",
    START_DATE: fmt(d.start_datetime),
    END_DATE: fmt(d.end_datetime),
  };
};

export const fillHtml = (html, vars) => Object.entries(vars).reduce((h, [k, v]) => h.split(`{{${k}}}`).join(v).split(`{${k}}`).join(v), html || "");

export default function CustomHtml({ d, html, loginPath, ctaPath }) {
  const doc = useMemo(() => {
    const filled = fillHtml(html, htmlPlaceholders(d, { loginPath, ctaPath }));
    const base = '<base target="_top">';
    return /<head[^>]*>/i.test(filled) ? filled.replace(/<head[^>]*>/i, (m) => m + base) : base + filled;
  }, [d, html, loginPath, ctaPath]);
  return <iframe title={d.name} srcDoc={doc} className="w-full min-h-screen block border-0" sandbox="allow-scripts allow-popups allow-forms" data-testid="landing-custom-html" />;
}
